// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"387":"ef36385681f10310","529":"743c401c73852bdf"}[chunkId] + ".js";
};